module.exports = __webpack_public_path__ + "img/cant-find.57f6b2d0.jpg";